// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse-border {
    0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7), inset 0 0 0 1px rgba(220, 38, 38, 0.5); }
    50% { box-shadow: 0 0 0 6px rgba(220, 38, 38, 0), inset 0 0 0 1px rgba(220, 38, 38, 0.9); }
  }

  @keyframes scanline {
    0% { transform: translateY(-100%); }
    100% { transform: translateY(100vh); }
  }

  @keyframes blink-status {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0; }
  }

  @keyframes ticker-move {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }

  @keyframes count-flash {
    0%, 100% { background: rgba(220, 38, 38, 0.15); color: #ef4444; }
    50% { background: rgba(220, 38, 38, 0.45); color: #fca5a5; }
  }

  @keyframes row-pulse {
    0%, 100% { background: rgba(220, 38, 38, 0.06); }
    50% { background: rgba(220, 38, 38, 0.14); }
  }

  @keyframes icon-rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes shimmer-line {
    0% { opacity: 0.3; }
    50% { opacity: 1; }
    100% { opacity: 0.3; }
  }

  .panel-wrap {
    background: #0a0f1a;
    border: 1px solid #1e3a5f;
    border-radius: 6px;
    overflow: hidden;
    font-family: 'Exo 2', sans-serif;
    position: relative;
  }

  .scanline-overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 10;
  }

  .scanline-bar {
    position: absolute;
    left: 0; right: 0;
    height: 2px;
    background: linear-gradient(transparent, rgba(0,180,255,0.06), transparent);
    animation: scanline 5s linear infinite;
  }

  .panel-header {
    background: #050c1a;
    border-bottom: 1px solid #1e3a5f;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .logo-icon {
    width: 28px;
    height: 28px;
    border: 1.5px solid #2563eb;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .panel-title {
    font-family: 'Share Tech Mono', monospace;
    font-size: 11px;
    color: #60a5fa;
    letter-spacing: 2.5px;
    text-transform: uppercase;
  }

  .panel-subtitle {
    font-size: 9px;
    color: #334155;
    letter-spacing: 1px;
    margin-top: 2px;
    font-family: 'Share Tech Mono', monospace;
  }

  .live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: 'Share Tech Mono', monospace;
    font-size: 9px;
    color: #22c55e;
    letter-spacing: 1px;
  }

  .live-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #22c55e;
    animation: blink-status 1s ease-in-out infinite;
  }

  .stat-bar {
    display: flex;
    gap: 1px;
    background: #050c1a;
    border-bottom: 1px solid #1e3a5f;
  }

  .stat-item {
    flex: 1 1;
    padding: 8px 12px;
    border-right: 1px solid #0f1e35;
  }

  .stat-item:last-child { border-right: none; }

  .stat-label {
    font-size: 8px;
    color: #475569;
    letter-spacing: 1.5px;
    font-family: 'Share Tech Mono', monospace;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .stat-value {
    font-family: 'Share Tech Mono', monospace;
    font-size: 18px;
    font-weight: 700;
  }

  .stat-value.critical {
    color: #ef4444;
    animation: count-flash 1.2s ease-in-out infinite;
    padding: 2px 6px;
    border-radius: 3px;
    display: inline-block;
  }

  .stat-value.warning { color: #f59e0b; }
  .stat-value.ok { color: #22c55e; }

  .table-header {
    display: grid;
    grid-template-columns: 40px 80px 90px 1fr 110px 50px 50px 50px 55px 50px;
    gap: 0;
    padding: 6px 12px;
    background: #071020;
    border-bottom: 1px solid #1e3a5f;
  }

  .th-cell {
    font-family: 'Share Tech Mono', monospace;
    font-size: 8px;
    color: #334155;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }

 

  .alert-row.critical {
    animation: row-pulse 1.8s ease-in-out infinite;
    border-left: 2px solid #ef4444;
  }

  .alert-row.critical:hover {
    background: rgba(220, 38, 38, 0.2) !important;
  }

  .alert-row.warning {
    border-left: 2px solid #f59e0b;
    background: rgba(245, 158, 11, 0.05);
  }

  .alert-row.warning:hover {
    background: rgba(245, 158, 11, 0.12) !important;
  }

  .cell {
    font-size: 11px;
    color: #94a3b8;
    font-family: 'Share Tech Mono', monospace;
  }

  .cell.id { color: #475569; font-size: 10px; }

  .sev-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 700;
    font-family: 'Share Tech Mono', monospace;
  }

  .sev-badge.sev-4 {
    background: rgba(220, 38, 38, 0.2);
    color: #ef4444;
    border: 1px solid rgba(220, 38, 38, 0.4);
    animation: pulse-border 1.5s ease-in-out infinite;
  }

  .sev-badge.sev-3 {
    background: rgba(245, 158, 11, 0.15);
    color: #f59e0b;
    border: 1px solid rgba(245, 158, 11, 0.3);
  }

  .status-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 7px;
    border-radius: 2px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1.5px;
    font-family: 'Share Tech Mono', monospace;
  }

  .status-chip.problem {
    background: rgba(220, 38, 38, 0.15);
    color: #ef4444;
    border: 0.5px solid rgba(220, 38, 38, 0.4);
    animation: blink-status 1.4s ease-in-out infinite;
  }

  .status-chip.ack {
    background: rgba(245, 158, 11, 0.15);
    color: #f59e0b;
    border: 0.5px solid rgba(245, 158, 11, 0.3);
  }

  .device-name {
    font-size: 11px;
    color: #60a5fa;
    font-family: 'Share Tech Mono', monospace;
  }

  .incidence-text {
    font-size: 11px;
    color: #cbd5e1;
  }

  .time-cell {
    font-family: 'Share Tech Mono', monospace;
    font-size: 9px;
    color: #475569;
    line-height: 1.4;
  }

  .time-cell span {
    display: block;
    color: #ef4444;
    font-size: 9px;
  }

  .shimmer-line {
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(239,68,68,0.3), transparent);
    animation: shimmer-line 2.5s ease-in-out infinite;
  }

  .ticker-wrap {
    background: #050c1a;
    border-top: 1px solid #1e3a5f;
    padding: 6px 0;
    overflow: hidden;
    position: relative;
  }

  .ticker-inner {
    display: inline-flex;
    gap: 40px;
    white-space: nowrap;
    animation: ticker-move 18s linear infinite;
  }

  .ticker-item {
    font-family: 'Share Tech Mono', monospace;
    font-size: 9px;
    color: #475569;
    letter-spacing: 1px;
  }

  .ticker-item.alert { color: #ef4444; }
  .ticker-item.ok { color: #22c55e; }

  .corner-tl, .corner-tr, .corner-bl, .corner-br {
    position: absolute;
    width: 10px;
    height: 10px;
    pointer-events: none;
  }

  .corner-tl { top: 0; left: 0; border-top: 1.5px solid #2563eb; border-left: 1.5px solid #2563eb; }
  .corner-tr { top: 0; right: 0; border-top: 1.5px solid #2563eb; border-right: 1.5px solid #2563eb; }
  .corner-bl { bottom: 0; left: 0; border-bottom: 1.5px solid #2563eb; border-left: 1.5px solid #2563eb; }
  .corner-br { bottom: 0; right: 0; border-bottom: 1.5px solid #2563eb; border-right: 1.5px solid #2563eb; }

  .no-ack { width: 10px; height: 10px; border-radius: 50%; background: transparent; border: 1px solid #1e3a5f; }
  .acked { width: 10px; height: 10px; border-radius: 50%; background: #f59e0b; }

  .sla-na {
    font-family: 'Share Tech Mono', monospace;
    font-size: 9px;
    color: #334155;
  }`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/Events/styles/alerts.css"],"names":[],"mappings":"AAAA;IACI,WAAW,kFAAkF,EAAE;IAC/F,MAAM,kFAAkF,EAAE;EAC5F;;EAEA;IACE,KAAK,4BAA4B,EAAE;IACnC,OAAO,4BAA4B,EAAE;EACvC;;EAEA;IACE,UAAU,UAAU,EAAE;IACtB,YAAY,UAAU,EAAE;EAC1B;;EAEA;IACE,KAAK,2BAA2B,EAAE;IAClC,OAAO,4BAA4B,EAAE;EACvC;;EAEA;IACE,WAAW,mCAAmC,EAAE,cAAc,EAAE;IAChE,MAAM,mCAAmC,EAAE,cAAc,EAAE;EAC7D;;EAEA;IACE,WAAW,mCAAmC,EAAE;IAChD,MAAM,mCAAmC,EAAE;EAC7C;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;EACvB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,OAAO,EAAE,QAAQ;IACjB,WAAW;IACX,2EAA2E;IAC3E,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,SAAO;IACP,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA,wBAAwB,kBAAkB,EAAE;;EAE5C;IACE,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gDAAgD;IAChD,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,sBAAsB,cAAc,EAAE;EACtC,iBAAiB,cAAc,EAAE;;EAEjC;IACE,aAAa;IACb,wEAAwE;IACxE,MAAM;IACN,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;;;EAIA;IACE,8CAA8C;IAC9C,8BAA8B;EAChC;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yCAAyC;EAC3C;;EAEA,WAAW,cAAc,EAAE,eAAe,EAAE;;EAE5C;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,kCAAkC;IAClC,cAAc;IACd,wCAAwC;IACxC,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,yCAAyC;EAC3C;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,0CAA0C;IAC1C,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,iFAAiF;IACjF,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,mBAAmB;EACrB;;EAEA,qBAAqB,cAAc,EAAE;EACrC,kBAAkB,cAAc,EAAE;;EAElC;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA,aAAa,MAAM,EAAE,OAAO,EAAE,+BAA+B,EAAE,gCAAgC,EAAE;EACjG,aAAa,MAAM,EAAE,QAAQ,EAAE,+BAA+B,EAAE,iCAAiC,EAAE;EACnG,aAAa,SAAS,EAAE,OAAO,EAAE,kCAAkC,EAAE,gCAAgC,EAAE;EACvG,aAAa,SAAS,EAAE,QAAQ,EAAE,kCAAkC,EAAE,iCAAiC,EAAE;;EAEzG,UAAU,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE;EAC7G,SAAS,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;EAE7E;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;EAChB","sourcesContent":["@keyframes pulse-border {\r\n    0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7), inset 0 0 0 1px rgba(220, 38, 38, 0.5); }\r\n    50% { box-shadow: 0 0 0 6px rgba(220, 38, 38, 0), inset 0 0 0 1px rgba(220, 38, 38, 0.9); }\r\n  }\r\n\r\n  @keyframes scanline {\r\n    0% { transform: translateY(-100%); }\r\n    100% { transform: translateY(100vh); }\r\n  }\r\n\r\n  @keyframes blink-status {\r\n    0%, 49% { opacity: 1; }\r\n    50%, 100% { opacity: 0; }\r\n  }\r\n\r\n  @keyframes ticker-move {\r\n    0% { transform: translateX(100%); }\r\n    100% { transform: translateX(-100%); }\r\n  }\r\n\r\n  @keyframes count-flash {\r\n    0%, 100% { background: rgba(220, 38, 38, 0.15); color: #ef4444; }\r\n    50% { background: rgba(220, 38, 38, 0.45); color: #fca5a5; }\r\n  }\r\n\r\n  @keyframes row-pulse {\r\n    0%, 100% { background: rgba(220, 38, 38, 0.06); }\r\n    50% { background: rgba(220, 38, 38, 0.14); }\r\n  }\r\n\r\n  @keyframes icon-rotate {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n\r\n  @keyframes shimmer-line {\r\n    0% { opacity: 0.3; }\r\n    50% { opacity: 1; }\r\n    100% { opacity: 0.3; }\r\n  }\r\n\r\n  .panel-wrap {\r\n    background: #0a0f1a;\r\n    border: 1px solid #1e3a5f;\r\n    border-radius: 6px;\r\n    overflow: hidden;\r\n    font-family: 'Exo 2', sans-serif;\r\n    position: relative;\r\n  }\r\n\r\n  .scanline-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    pointer-events: none;\r\n    overflow: hidden;\r\n    z-index: 10;\r\n  }\r\n\r\n  .scanline-bar {\r\n    position: absolute;\r\n    left: 0; right: 0;\r\n    height: 2px;\r\n    background: linear-gradient(transparent, rgba(0,180,255,0.06), transparent);\r\n    animation: scanline 5s linear infinite;\r\n  }\r\n\r\n  .panel-header {\r\n    background: #050c1a;\r\n    border-bottom: 1px solid #1e3a5f;\r\n    padding: 10px 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n  }\r\n\r\n  .header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n\r\n  .logo-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    border: 1.5px solid #2563eb;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .panel-title {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 11px;\r\n    color: #60a5fa;\r\n    letter-spacing: 2.5px;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .panel-subtitle {\r\n    font-size: 9px;\r\n    color: #334155;\r\n    letter-spacing: 1px;\r\n    margin-top: 2px;\r\n    font-family: 'Share Tech Mono', monospace;\r\n  }\r\n\r\n  .live-indicator {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 9px;\r\n    color: #22c55e;\r\n    letter-spacing: 1px;\r\n  }\r\n\r\n  .live-dot {\r\n    width: 6px;\r\n    height: 6px;\r\n    border-radius: 50%;\r\n    background: #22c55e;\r\n    animation: blink-status 1s ease-in-out infinite;\r\n  }\r\n\r\n  .stat-bar {\r\n    display: flex;\r\n    gap: 1px;\r\n    background: #050c1a;\r\n    border-bottom: 1px solid #1e3a5f;\r\n  }\r\n\r\n  .stat-item {\r\n    flex: 1;\r\n    padding: 8px 12px;\r\n    border-right: 1px solid #0f1e35;\r\n  }\r\n\r\n  .stat-item:last-child { border-right: none; }\r\n\r\n  .stat-label {\r\n    font-size: 8px;\r\n    color: #475569;\r\n    letter-spacing: 1.5px;\r\n    font-family: 'Share Tech Mono', monospace;\r\n    text-transform: uppercase;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .stat-value {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .stat-value.critical {\r\n    color: #ef4444;\r\n    animation: count-flash 1.2s ease-in-out infinite;\r\n    padding: 2px 6px;\r\n    border-radius: 3px;\r\n    display: inline-block;\r\n  }\r\n\r\n  .stat-value.warning { color: #f59e0b; }\r\n  .stat-value.ok { color: #22c55e; }\r\n\r\n  .table-header {\r\n    display: grid;\r\n    grid-template-columns: 40px 80px 90px 1fr 110px 50px 50px 50px 55px 50px;\r\n    gap: 0;\r\n    padding: 6px 12px;\r\n    background: #071020;\r\n    border-bottom: 1px solid #1e3a5f;\r\n  }\r\n\r\n  .th-cell {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 8px;\r\n    color: #334155;\r\n    letter-spacing: 1.2px;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n \r\n\r\n  .alert-row.critical {\r\n    animation: row-pulse 1.8s ease-in-out infinite;\r\n    border-left: 2px solid #ef4444;\r\n  }\r\n\r\n  .alert-row.critical:hover {\r\n    background: rgba(220, 38, 38, 0.2) !important;\r\n  }\r\n\r\n  .alert-row.warning {\r\n    border-left: 2px solid #f59e0b;\r\n    background: rgba(245, 158, 11, 0.05);\r\n  }\r\n\r\n  .alert-row.warning:hover {\r\n    background: rgba(245, 158, 11, 0.12) !important;\r\n  }\r\n\r\n  .cell {\r\n    font-size: 11px;\r\n    color: #94a3b8;\r\n    font-family: 'Share Tech Mono', monospace;\r\n  }\r\n\r\n  .cell.id { color: #475569; font-size: 10px; }\r\n\r\n  .sev-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 3px;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    font-family: 'Share Tech Mono', monospace;\r\n  }\r\n\r\n  .sev-badge.sev-4 {\r\n    background: rgba(220, 38, 38, 0.2);\r\n    color: #ef4444;\r\n    border: 1px solid rgba(220, 38, 38, 0.4);\r\n    animation: pulse-border 1.5s ease-in-out infinite;\r\n  }\r\n\r\n  .sev-badge.sev-3 {\r\n    background: rgba(245, 158, 11, 0.15);\r\n    color: #f59e0b;\r\n    border: 1px solid rgba(245, 158, 11, 0.3);\r\n  }\r\n\r\n  .status-chip {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    padding: 2px 7px;\r\n    border-radius: 2px;\r\n    font-size: 9px;\r\n    font-weight: 700;\r\n    letter-spacing: 1.5px;\r\n    font-family: 'Share Tech Mono', monospace;\r\n  }\r\n\r\n  .status-chip.problem {\r\n    background: rgba(220, 38, 38, 0.15);\r\n    color: #ef4444;\r\n    border: 0.5px solid rgba(220, 38, 38, 0.4);\r\n    animation: blink-status 1.4s ease-in-out infinite;\r\n  }\r\n\r\n  .status-chip.ack {\r\n    background: rgba(245, 158, 11, 0.15);\r\n    color: #f59e0b;\r\n    border: 0.5px solid rgba(245, 158, 11, 0.3);\r\n  }\r\n\r\n  .device-name {\r\n    font-size: 11px;\r\n    color: #60a5fa;\r\n    font-family: 'Share Tech Mono', monospace;\r\n  }\r\n\r\n  .incidence-text {\r\n    font-size: 11px;\r\n    color: #cbd5e1;\r\n  }\r\n\r\n  .time-cell {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 9px;\r\n    color: #475569;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .time-cell span {\r\n    display: block;\r\n    color: #ef4444;\r\n    font-size: 9px;\r\n  }\r\n\r\n  .shimmer-line {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    height: 1px;\r\n    background: linear-gradient(90deg, transparent, rgba(239,68,68,0.3), transparent);\r\n    animation: shimmer-line 2.5s ease-in-out infinite;\r\n  }\r\n\r\n  .ticker-wrap {\r\n    background: #050c1a;\r\n    border-top: 1px solid #1e3a5f;\r\n    padding: 6px 0;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n\r\n  .ticker-inner {\r\n    display: inline-flex;\r\n    gap: 40px;\r\n    white-space: nowrap;\r\n    animation: ticker-move 18s linear infinite;\r\n  }\r\n\r\n  .ticker-item {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 9px;\r\n    color: #475569;\r\n    letter-spacing: 1px;\r\n  }\r\n\r\n  .ticker-item.alert { color: #ef4444; }\r\n  .ticker-item.ok { color: #22c55e; }\r\n\r\n  .corner-tl, .corner-tr, .corner-bl, .corner-br {\r\n    position: absolute;\r\n    width: 10px;\r\n    height: 10px;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .corner-tl { top: 0; left: 0; border-top: 1.5px solid #2563eb; border-left: 1.5px solid #2563eb; }\r\n  .corner-tr { top: 0; right: 0; border-top: 1.5px solid #2563eb; border-right: 1.5px solid #2563eb; }\r\n  .corner-bl { bottom: 0; left: 0; border-bottom: 1.5px solid #2563eb; border-left: 1.5px solid #2563eb; }\r\n  .corner-br { bottom: 0; right: 0; border-bottom: 1.5px solid #2563eb; border-right: 1.5px solid #2563eb; }\r\n\r\n  .no-ack { width: 10px; height: 10px; border-radius: 50%; background: transparent; border: 1px solid #1e3a5f; }\r\n  .acked { width: 10px; height: 10px; border-radius: 50%; background: #f59e0b; }\r\n\r\n  .sla-na {\r\n    font-family: 'Share Tech Mono', monospace;\r\n    font-size: 9px;\r\n    color: #334155;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
